import { DomainUri } from '../../state/types/domain-registry.ts';
import { type Reason, reason } from '../../reason.ts';

export function contextNotAuthorized(domainUri: DomainUri) {
    return `${domainUri}.errors.not_authorized`;
}
export function contextBadLifetime(domainUri: DomainUri) {
    return `${domainUri}.errors.bad_lifetime`;
}

export function contextInvalidContext(domainUri: DomainUri) {
    return `${domainUri}.errors.invalid_context`;
}

export function contextUnhandledMessage(domainUri: DomainUri) {
    return `${domainUri}.errors.unhandled_message`;
}

export function contextDestroyedExplicitly(domainUri: DomainUri): Reason {
    return reason(`${domainUri}.destroyed`, 'Context destroyed explicitly');
}

export function contextDestroyedPeerLeft(domainUri: DomainUri): Reason {
    return reason(`${domainUri}.peer-left`, 'Context destroyed because its owner/last peer left');
}

export function failure(domainUri: DomainUri) {
    return `${domainUri}.errors.failure`;
}
